import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Navbar, Nav, Button } from 'react-bootstrap';
import { useEhrIntegrationSettings } from '@/common/contexts';

const SiteNavbar = () => {
  const ehrSettings = useEhrIntegrationSettings();
  const [expanded, setExpanded] = useState(false);
  const handleNavClick = () => setExpanded(false);

  return (
    <Navbar
      bg="light-subtle"
      expand="lg"
      className="border-bottom py-2"
      expanded={expanded}
      onToggle={setExpanded}
    >
      <Container>
        <Navbar.Brand
          as={Link}
          to="/"
          className="d-flex align-items-center gap-2 me-auto"
          onClick={handleNavClick}
        >
          <img
            src="/images/afh-logo-small.webp"
            alt="Aspen Functional Health logo"
            height="50"
            className="me-2"
          />
          Aspen Functional Health
        </Navbar.Brand>

        <Link
          to="/providers"
          className="d-none d-lg-block ms-3"
          onClick={handleNavClick}
        >
          <Button variant="primary" size="sm">
            Find a Dietitian
          </Button>
        </Link>

        <Navbar.Toggle aria-controls="main-navbar" />
        <Navbar.Collapse id="main-navbar" className="justify-content-end">
          <Nav className="align-items-center gap-2">
            <Nav.Link as={Link} to="/" onClick={handleNavClick}>
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/providers" onClick={handleNavClick}>
              Dietitians
            </Nav.Link>
            <Nav.Link as={Link} to="/about" onClick={handleNavClick}>
              About Us
            </Nav.Link>
            <Nav.Link as={Link} to="/patient-referral" onClick={handleNavClick}>
              <Button variant="outline-primary" size="sm">
                Refer a Patient
              </Button>
            </Nav.Link>
            <Nav.Item className="mx-4">
              <Button
                variant="info"
                size="sm"
                onClick={() => {
                  setExpanded(false);
                  window.open(
                    ehrSettings?.patientLoginUrl,
                    '_blank',
                    'noopener,noreferrer'
                  );
                }}
              >
                Patient Login
              </Button>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
export default SiteNavbar;
